/**
 * Source-exemple - https://www.dofactory.com/javascript/design-patterns/observer
 *
 * @file JS - Événements internes - Evenements.js
 * @author Adam Lemire
 * @since 2021/08/30
 * @version 1.0
 * @summary Dernières modifications : 2021/09/10
 */

/** @description notifie lorsqu'une DataPage est ajoutée */
class Evenement {
  constructor () {
    this.handlers = []; // observers
  }

  subscribe (fn) {
    this.handlers.push(fn);
  }

  unsubscribe (fn) {
    this.handlers = this.handlers.filter(
      function (item) {
        if (item !== fn) {
          return item;
        } else return false;
      }
    );
  }

  notify (o, thisObj) {
    const scope = thisObj || window;
    if (this.handlers.length > 0) {
      this.handlers.forEach(function (item) {
        item && item.call(scope, o);
      });
    }
  }
}

export const Evenements = {
  changementProjetActif: new Evenement(),
  dataPageAjoutee: new Evenement(),
  dataPageSupprimee: new Evenement(),
  doitEnregistrer: new Evenement(),
  erreurObtenirListeCouchesServeur: new Evenement(),
  fermetureMiseEnForme: new Evenement(),
  langueAffichageChangee: new Evenement(),
  pageCarteAffichee: new Evenement(),
  redimensionnementFenetre: new Evenement(),
  texteAjoute: new Evenement(),
  vectorLayerSourceChangee: new Evenement()
};

/** @description réinitialise les listeners des événements */
export function reinitialiserEvenements () {
  Evenements.dataPageAjoutee = new Evenement();
  Evenements.dataPageSupprimee = new Evenement();
  Evenements.langueAffichageChangee = new Evenement();
  Evenements.redimensionnementFenetre = new Evenement();
  Evenements.doitEnregistrer = new Evenement();
}

/* EXEMPLE DE FONCTIONNEMENT
function run () {
  const clickHandler = function (item) {
    console.log('fired: ' + item);
  };

  const click = new Click();

  click.subscribe(clickHandler);
  click.notify('event #1');
  click.unsubscribe(clickHandler);
  click.notify('event #2');
  click.subscribe(clickHandler);
  click.notify('event #3');
} */

/*
  Exemple de listener multiple local, qui ne fait pas appel à ce fichier. Doit avoir un array de listener vide dans la constructeur, _langueAffichageChangeeListeners dans cet exemple
   registerLangueAffichageChangeeListener (listener) {
    const _this = this;
    this._langueAffichageChangeeListeners.push(listener);
    this._notifierLangueAffichageChangee = function (element) {
      _this._langueAffichageChangeeListeners.forEach(function (mListener) {
        mListener();
      });
    };
  }
*/
